// extracted by mini-css-extract-plugin
export default {"container":"deleteuser_container__lva0i","sessionExpiry":"deleteuser_sessionExpiry__xgRTZ","header":"deleteuser_header__G84h1","titleHeader":"deleteuser_titleHeader__jAMu8"};